import App from "./App";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Topbar from "./components/topBar";
import WhatsAppButton from "./components/WhatsApp";
import NavBar from "./NavBar";

export default function Site() {
  return (
    <>
      <Topbar />
      <NavBar />
      <ScrollToTop />
      <App />
      <Footer />
      <WhatsAppButton />
    </>
  );
}
